/* eslint-disable import/prefer-default-export */
import Http from '../../http';

// redux-less action
export const updateInvoiceStatus = (ownerType, ownerId, subscriptionId, invoiceId, action, payload = {}) => {
  const url = `/${ownerType}/${ownerId}/memberships/subscriptions/${subscriptionId}/invoices/${invoiceId}`;
  return Http.put(url, { ...payload, action });
};
